import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import branchApi from "../../services/branchapi";
import { BiCloudDownload } from "react-icons/bi";
import Form from "react-bootstrap/Form";
import Alert from "react-bootstrap/Alert";
import "./branchDetail.css";


const BranchDetails = ({ invModal, invoiceId, change }) => {
  const [invoiceModal, setInvoiceModal] = useState(invModal);
  const [branchDetails, setBranchDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);
  const handleInvoiceClose = () => {
    setInvoiceModal(false);
    change();
  };

  const accessData = JSON.parse(localStorage.getItem("accessData") || "{}");
  const isSuperAdmin = Number(accessData?.roleId || 0) === 1;

  // const [enableRazorpay, setEnableRazorpay] = useState(0);
  // const [initialEnableRazorpay, setInitialEnableRazorpay] = useState(0);

  const emptyGatewayConfig = {
    enablePayment: 0,
    enableRazorpay: 0,
    enablePayu: 0,
    primaryGateway: "",
    reason: "",
  };

  const [
    gatewayConfig,
    setGatewayConfig,
  ] = useState(
    emptyGatewayConfig
  );

  const [
    initialGatewayConfig,
    setInitialGatewayConfig,
  ] = useState(
    emptyGatewayConfig
  );


  useEffect(() => {
    setIsLoading(true);
    const fetchBranchDetail = async () => {
      try {
        const data = await branchApi.getBranchById({ id: invoiceId });
        if (data) {
          const branch =
            data.data.result[0];

          setBranchDetails(branch);

          const config = {
            enablePayment:
              Number(
                branch.enablePayment ??
                branch.enable_payment ??
                0
              ),
            enableRazorpay:
              Number(
                branch.enableRazorpay ??
                branch.enable_razorpay ??
                0
              ),
            enablePayu:
              Number(
                branch.enablePayu ??
                branch.enable_payu ??
                0
              ),
            primaryGateway:
              String(
                branch
                  .primaryPaymentGateway ??
                branch
                  .primary_payment_gateway ??
                ""
              ).toUpperCase(),
            reason: "",
          };

          setGatewayConfig(config);
          setInitialGatewayConfig(config);
          setIsLoading(false);
        }
      } catch (e) {
        console.error("Failed to fetch branch:", e);
      }
    };
    fetchBranchDetail();
  }, [invoiceId]);

  const isDirty =
    JSON.stringify({
      ...gatewayConfig,
      reason: "",
    }) !==
    JSON.stringify({
      ...initialGatewayConfig,
      reason: "",
    });

  const handleGatewayToggle = (gateway, checked) => {
    setGatewayConfig((previous) => {
      const nextRazorpay =
        gateway === "RAZORPAY"
          ? checked ? 1 : 0
          : Number(previous.enableRazorpay);
      const nextPayu =
        gateway === "PAYU"
          ? checked ? 1 : 0
          : Number(previous.enablePayu);

      return {
        ...previous,
        enablePayment: nextRazorpay || nextPayu ? 1 : 0,
        enableRazorpay: nextRazorpay,
        enablePayu: nextPayu,
        primaryGateway:
          !checked && previous.primaryGateway === gateway
            ? ""
            : previous.primaryGateway,
      };
    });
  };

  return (
    <div>
      <Modal
        show={invoiceModal}
        onHide={handleInvoiceClose}
        centered
        dialogClassName="branch-details-modal"
      >
        {isLoading ? (
          "Branch detail is loading...."
        ) : (
          <>
            <div id="invoiceCapture">
              {msg && (
                <div className="w-100 p-2">
                  <Alert
                    variant={msg.type}
                    className="py-2 px-2 mt-2 mb-1"
                    dismissible
                    onClose={() => setMsg(null)}
                  >
                    {msg.text}
                  </Alert>
                </div>
              )}
              <div className="branch-details-body">
                <Row className="g-5">
                  <Col md={6}>
                    <h5 className="fw-bold mb-3">
                      {branchDetails.branchName}
                    </h5>

                    <div className="branch-info-line">
                      Branch Code : {branchDetails.code || ""}
                    </div>
                    <div className="branch-info-line">
                      Status : {branchDetails.status === 1 ? "Active" : "Inactive"}
                    </div>
                    <div className="branch-info-line">
                      Email: {branchDetails.email || "N/A"}
                    </div>
                    <div className="branch-info-line">
                      Mobile: {branchDetails.mobile || branchDetails.phone || "N/A"}
                    </div>
                    <div className="branch-info-line">
                      Alternative Mobile: {branchDetails.alternativeMobile || "N/A"}
                    </div>
                    <div className="branch-info-line">
                      Alternative Email: {branchDetails.alternativeEmail || "N/A"}
                    </div>

                    <div className="fw-bold branch-address-title">
                      Branch Address:
                    </div>
                    <div className="branch-info-line">{branchDetails.address || ""}</div>
                    <div className="branch-info-line">
                      {[branchDetails.areaName, branchDetails.city]
                        .filter(Boolean)
                        .join(", ")}
                    </div>
                    <div className="branch-info-line">
                      {[branchDetails.state, branchDetails.country]
                        .filter(Boolean)
                        .join(", ")}
                    </div>
                    <div className="branch-info-line">Pincode: {branchDetails.pincode || ""}</div>
                    <div className="branch-info-line">Latitude: {branchDetails.latitude || ""}</div>
                    <div className="branch-info-line">Longitude: {branchDetails.longitude || ""}</div>
                  </Col>

                  <Col md={6}>

                  {!isSuperAdmin && (
                    <Alert
                      variant="warning"
                      className="py-1 px-2 mt-2 mb-1"
                    >
                      Only Super Admin can change
                      payment gateway settings.
                    </Alert>
                  )}

                  <Form.Check
                    type="switch"
                    id="enableRazorpay"
                    label="Enable Razorpay"
                    className="gateway-switch"
                    checked={
                      Number(
                        gatewayConfig
                          .enableRazorpay
                      ) === 1
                    }
                    disabled={
                      !isSuperAdmin ||
                      saving
                    }
                    onChange={(event) =>
                      handleGatewayToggle("RAZORPAY", event.target.checked)
                    }
                  />

                  <Form.Check
                    type="switch"
                    id="enablePayu"
                    label="Enable PayU"
                    className="gateway-switch"
                    checked={
                      Number(
                        gatewayConfig
                          .enablePayu
                      ) === 1
                    }
                    disabled={
                      !isSuperAdmin ||
                      saving
                    }
                    onChange={(event) =>
                      handleGatewayToggle("PAYU", event.target.checked)
                    }
                  />

                  <Form.Group className="gateway-field">
                    <Form.Label className="fw-semibold text-secondary">
                      Primary Payment Gateway
                    </Form.Label>

                    <Form.Select
                      value={
                        gatewayConfig
                          .primaryGateway
                      }
                      disabled={
                        !isSuperAdmin ||
                        saving ||
                        (Number(gatewayConfig.enableRazorpay) !== 1 &&
                          Number(gatewayConfig.enablePayu) !== 1)
                      }
                      onChange={(event) =>
                        setGatewayConfig(
                          (previous) => ({
                            ...previous,
                            primaryGateway:
                              event.target
                                .value,
                          })
                        )
                      }
                    >
                      <option value="">
                        Select Gateway
                      </option>

                      {Number(
                        gatewayConfig
                          .enableRazorpay
                      ) === 1 && (
                          <option value="RAZORPAY">
                            Razorpay
                          </option>
                        )}

                      {Number(
                        gatewayConfig
                          .enablePayu
                      ) === 1 && (
                          <option value="PAYU">
                            PayU
                          </option>
                        )}
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="gateway-field">
                    <Form.Label className="fw-semibold text-secondary">
                      Change Reason
                    </Form.Label>

                    <Form.Control
                      as="textarea"
                      rows={4}
                      value={
                        gatewayConfig.reason
                      }
                      disabled={
                        !isSuperAdmin ||
                        saving
                      }
                      onChange={(event) =>
                        setGatewayConfig(
                          (previous) => ({
                            ...previous,
                            reason:
                              event.target
                                .value,
                          })
                        )
                      }
                      placeholder="Enter reason for changing the gateway"
                    />
                  </Form.Group>

                  </Col>
                </Row>
              </div>
            </div>

            <div className="branch-details-footer">
              <Row className="g-5">
                <Col md={6}>
                  <Button
                    variant="danger"
                    className="d-block w-100"
                    onClick={handleInvoiceClose}
                  >
                    Close
                  </Button>
                </Col>
                <Col md={6}>
                  <Button
                    variant="danger"
                    className="d-block w-100"
                    disabled={
                      !isSuperAdmin ||
                      saving ||
                      !isDirty ||
                      !gatewayConfig.reason.trim()
                    }
                    onClick={async () => {
                      try {
                        setSaving(true);
                        setMsg(null);

                        if (
                          Number(gatewayConfig.enablePayment) === 1 &&
                          !gatewayConfig.primaryGateway
                        ) {
                          throw new Error(
                            "Please select the primary payment gateway."
                          );
                        }

                        const response =
                          await branchApi.updateBranchPaymentGatewayConfig({
                            branchId: invoiceId,
                            ...gatewayConfig,
                          });

                        if (
                          response?.data?.status === "SUCCESS" ||
                          response?.status === "SUCCESS"
                        ) {
                          setMsg({
                            type: "success",
                            text: "Payment gateway configuration updated.",
                          });

                          setInitialGatewayConfig({
                            ...gatewayConfig,
                            reason: "",
                          });
                          setGatewayConfig((previous) => ({
                            ...previous,
                            reason: "",
                          }));
                        } else {
                          throw new Error(
                            response?.data?.message || "Update failed"
                          );
                        }
                      } catch (error) {
                        setMsg({
                          type: "danger",
                          text:
                            error?.response?.data?.message ||
                            error.message ||
                            "Update failed",
                        });
                      } finally {
                        setSaving(false);
                      }
                    }}
                  >
                    {saving ? "Saving..." : "Save Gateway Configuration"}
                  </Button>
                </Col>
              </Row>
            </div>
          </>
        )}
      </Modal>
      <hr className="mt-4 mb-3" />
    </div>
  );
};

export default BranchDetails;
